import { LayoutTable } from 'xui-pro';
import useColumns from './useColumns';
import type { WorkItem } from './type';

type Props = {
  dataSource: WorkItem[];
};

export const WITable = ({ dataSource }: Props) => {
  const columns = useColumns();

  return (
    <LayoutTable
      hasToolbar={false}
      scroll={{ y: 40 * 5 }}
      columns={columns}
      pagination={false}
      dataSource={dataSource}
    />
  );
};
